import { withValidation } from './Validation';
import { createInputId } from '../../utils/utilities';
import Checkbox from '../Inputs/Checkbox';

const QuestionTextbox = ({ value, label, showError, name, handleChange }) => {
    const handleChangeDecorator = e => {
        handleChange({
            target: {
                value: e.target.checked
            }
        })
    }

    return (
        <div className='flex [&>div]:mr-2 items-center' id={name}>
            <Checkbox
                id={createInputId(name)}
                checked={value || false}
                className={`${showError ? '[&>span]:text-cherry-red' : '[&>span]:text-secondary-blue'}`}
                onChange={handleChangeDecorator}
            />

            <h6
                className={`text-base m-0 font-normal cursor-pointer ${showError ? 'text-cherry-red' : 'text-primary-blue'}`}
                dangerouslySetInnerHTML={{ __html: label }}
                onClick={() => handleChangeDecorator({ target: { checked: !value } })}
            />
        </div>
    );
}

export default withValidation(QuestionTextbox);